import React, {Component} from 'react';
import {Drawer, Tree} from 'antd';
import {queryOrgUserList} from '@api/core/user';

const { TreeNode } = Tree;
class DrawerOther extends Component {
  constructor(props) {
    super(props);
    this.state = {
      orglist: [],
      expandKeys: [],
      checkedObjs: [],
      checkedKeys: [],
    };
  }

  componentDidMount() {
    const checkedKeys = [];
    let expandKeys = [];
    const checkedObjs = [];
    const { views } = this.props;
    queryOrgUserList().then(res => {
      if (res.statusCode === 200) {
        this.setState({
          orglist: res.data,
        });

        views &&
          views.map(item => {
            checkedKeys.push(item.uuid);
            checkedObjs.push({
              uuid: item.uuid,
              name: item.name,
            });
            expandKeys = expandKeys.concat(this.getParentKey(item.uuid, res.data));
            return item;
          });
        expandKeys = expandKeys.filter((item, i, self) => item && self.indexOf(item) === i);
        this.setState({
          checkedKeys,
          checkedObjs,
          expandKeys,
        });
      }
    });
  }

  // 找到该目录的所有父级目录（及以上）
  getParentKey = (key, tree, grandKeys) => {
    let parentKey;
    const grandKey = grandKeys || [];
    tree.map(item => {
      if (item.children) {
        if (item.children.some(it => it.uuid === key)) {
          grandKey.push(item.uuid);
          parentKey = grandKey;
        } else if (this.getParentKey(key, item.children)) {
          grandKey.push(item.uuid);
          parentKey = this.getParentKey(key, item.children, grandKey);
        }
      }
      return item;
    });
    return parentKey;
  };

  // 复选框选中
  onCheck = (checkedKey, e) => {
    const { dataRef } = e.node.props;
    let { checkedKeys, checkedObjs } = this.state;
    if (e.checked) {
      checkedKeys.push(dataRef.uuid);
      checkedObjs.push({
        uuid: dataRef.uuid,
        name: dataRef.name,
      });
    } else {
      checkedKeys = checkedKeys.filter(item => item !== dataRef.uuid);
      checkedObjs = checkedObjs.filter(item => item.uuid !== dataRef.uuid);
    }
    this.setState({
      checkedKeys,
      checkedObjs,
    });
    this.props.setViews(checkedObjs);
  };

  // 展开
  onExpand = (Key, e) => {
    const { dataRef } = e.node.props;
    let { expandKeys } = this.state;

    if (e.expanded) {
      expandKeys.push(dataRef.uuid);
    } else {
      expandKeys = expandKeys.filter(item => item !== dataRef.uuid);
    }
    this.setState({
      expandKeys: Key,
    });
  };

  renderTreeNodes = data => {
    return data.map(item => {
      if (item.children) {
        return (
          <TreeNode title={item.name} key={item.uuid} dataRef={item}>
            {this.renderTreeNodes(item.children)}
          </TreeNode>
        );
      }
      return <TreeNode title={item.name} key={item.uuid} {...item} dataRef={item} />;
    });
  };

  render() {
    const { orglist } = this.state;
    const { checkedKeys, expandKeys } = this.state;
    return (
      <Drawer
        title="其他查看权限"
        placement="right"
        closable={false}
        getContainer={false}
        onClose={this.props.onClose}
        visible={this.props.visible}
        width="30%"
      >
        <Tree
          key={Date.now()}
          onExpand={this.onExpand}
          expandedKeys={expandKeys}
          checkable
          checkStrictly
          onCheck={this.onCheck}
          checkedKeys={checkedKeys}
          autoExpandParent={false}
        >
          {this.renderTreeNodes(orglist || [])}
        </Tree>
      </Drawer>
    );
  }
}
export default DrawerOther;



// WEBPACK FOOTER //
// ./src/components/comm/orgStructure/orgStructure.js